import { IApplicationState } from '../../types/redux';
import { createSelector } from '@reduxjs/toolkit';

export const getDictionaries = (state: IApplicationState) => state.dictionaries.data;

export const getAvailableBanks = (state: IApplicationState) => getDictionaries(state).banks;

export const getAvailableRegions = (state: IApplicationState) => getDictionaries(state).availableRegions;

export const getRegionsOptions = createSelector(getAvailableRegions, state =>
  state.map(({ id, name }) => ({ value: id.toString(), label: name })),
);

export const getBanksOptions = createSelector(getAvailableBanks, state => {
  const availableBanks = state.map(({ id, title }) => ({ value: id.toString(), label: title }));

  return [{ label: 'Нет зарплатного проекта', value: '0' }, ...availableBanks, { label: 'Другой банк', value: '-1' }];
});

export const getBanksLogos = createSelector(getAvailableBanks, state => {
  return state.reduce((acc: string[], { logoUrl }) => {
    acc.push(logoUrl);

    return acc;
  }, []);
});
